module.exports = __webpack_public_path__ + "img/patch-minus-fill.afdc08d4.svg";